<kendo-appbar
	position="top"
	[ngClass]="isZenith ? 'k-zenith-appbar' : 'k-not-zenith-appbar'">
	<kendo-appbar-section>
		<button
			*ngIf="isMobile"
			class="toggle-btn"
			(click)="onToggleSidenav()">
			☰
		</button>
		<div
			*ngIf="!isMobile && !isZenith"
			class="kpa-navbar-title">
			Risk Management Center
		</div>
	</kendo-appbar-section>
	<kendo-appbar-spacer></kendo-appbar-spacer>
	<kendo-appbar-section class="actions">
		<kendo-dropdownlist
			[size]="'small'"
			[rounded]="'medium'"
			[fillMode]="'outline'"
			[data]="trainingLanguages"
			textField="localizedName"
			valueField="languageId"
			[(ngModel)]="selectedLanguage"
			(valueChange)="onLanguageChange()">
			<ng-template
				kendoDropDownListValueTemplate
				let-dataItem>
				<span class="template">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none">
						<path
							d="M6.20017 2.19998C6.20017 1.8686 5.93154 1.59998 5.60017 1.59998C5.2688 1.59998 5.00017 1.8686 5.00017 2.19998V3.20671C4.02668 3.2286 3.0661 3.3036 2.12124 3.42899C1.79275 3.47258 1.56179 3.77421 1.60538 4.1027C1.64897 4.4312 1.9506 4.66215 2.2791 4.61856C3.36536 4.47441 4.47392 4.39998 5.60017 4.39998C6.05662 4.39998 6.51016 4.4122 6.96048 4.43634C6.62618 5.56546 6.16743 6.64132 5.60007 7.64798C5.30214 7.11938 5.03417 6.5717 4.79844 6.00727C4.67074 5.7015 4.31934 5.55714 4.01356 5.68484C3.70778 5.81254 3.56343 6.16395 3.69113 6.46972C4.02943 7.27978 4.4293 8.05759 4.88484 8.79734C4.02934 10.0478 2.99641 11.1676 1.82212 12.1204C1.5648 12.3292 1.52546 12.7071 1.73425 12.9644C1.94304 13.2217 2.32089 13.2611 2.57821 13.0523C3.71858 12.127 4.73545 11.0551 5.60007 9.86513C5.67642 9.97021 5.75396 10.0744 5.83267 10.1776C6.03359 10.4411 6.41009 10.4918 6.67359 10.2909C6.9371 10.09 6.98783 9.71349 6.78691 9.44998C6.62426 9.23668 6.46699 9.01906 6.3153 8.79734C7.12383 7.48441 7.75691 6.05162 8.18173 4.5316C8.42933 4.55699 8.67585 4.586 8.92124 4.61856C9.24973 4.66215 9.55136 4.4312 9.59495 4.1027C9.63854 3.77421 9.40759 3.47258 9.0791 3.42899C8.64924 3.37195 8.21613 3.32533 7.78001 3.2894C7.25753 3.24635 6.73076 3.21864 6.20017 3.20671V2.19998Z"
							fill="#6B778C" />
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M10.4002 6.39998C10.6275 6.39998 10.8353 6.52838 10.9369 6.73165L14.3369 13.5316C14.4851 13.828 14.3649 14.1884 14.0686 14.3366C13.7722 14.4848 13.4118 14.3647 13.2636 14.0683L12.6294 12.8H8.17105L7.53689 14.0683C7.38869 14.3647 7.02829 14.4848 6.7319 14.3366C6.43551 14.1884 6.31538 13.828 6.46357 13.5316L9.86357 6.73165C9.96521 6.52838 10.173 6.39998 10.4002 6.39998ZM12.0294 11.6L10.4002 8.34162L8.77105 11.6H12.0294Z"
							fill="#6B778C" /></svg></span
				>&nbsp;{{ dataItem?.localizedName }}
			</ng-template>
		</kendo-dropdownlist>
		<kendo-appbar-spacer width="20px"></kendo-appbar-spacer>
		<div class="nav-profile nav-circle">
			<div
				id="qa-profile-icon"
				class="qa-profile-icon">
				<div
					*ngIf="employee"
					id="initials"
					class="initials">
					{{ employee.initials }}
				</div>
				<img
					style="display: none"
					class="profile-pic"
					src="" />
				<div
					class="profile-name notranslate"
					(click)="logout()">
					Log Out
				</div>
			</div>
		</div>
	</kendo-appbar-section>
</kendo-appbar>
